import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Tooltip from 'components/common/Tooltip';

import hexToRgb from 'styles/hexToRgb';
import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    width: 3,
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  state: {
    width: '100%',
    height: '100%',
    borderRadius: 4,
    backgroundColor: theme.palette.states.archive,
  },
  stateIntake: {
    backgroundColor: theme.palette.states.intake,
    '&$stateDelivery': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 50%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.delivery} 100%)`
    },
    '&$stateBilling': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 50%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.billing} 100%)`
    },
    '&$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 50%,
        ${theme.palette.states.paid} 50%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 50%,
        ${theme.palette.states.archive} 50%,
        ${theme.palette.states.archive} 100%)`
    },

    '&$stateDelivery$stateBilling': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.delivery} 66%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.billing} 100%)`
    },
    '&$stateDelivery$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.delivery} 66%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$stateDelivery$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.delivery} 66%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateDelivery$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.delivery} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateBilling$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$stateBilling$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateBilling$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateCollection$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.collection} 33%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateCollection$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.collection} 33%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$statePaid$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 33%,
        ${theme.palette.states.paid} 33%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },

    '&$stateDelivery$stateBilling$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.delivery} 25%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.billing} 75%,
        ${theme.palette.states.collection} 75%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$stateDelivery$stateBilling$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.delivery} 25%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.billing} 75%,
        ${theme.palette.states.paid} 75%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateDelivery$stateBilling$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.delivery} 25%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.billing} 75%,
        ${theme.palette.states.archive} 75%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateDelivery$stateCollection$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.delivery} 25%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 75%,
        ${theme.palette.states.paid} 75%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateDelivery$stateCollection$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.delivery} 25%,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 75%,
        ${theme.palette.states.archive} 75%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateBilling$stateCollection$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.billing} 25%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 75%,
        ${theme.palette.states.paid} 75%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateBilling$stateCollection$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 25%,
        ${theme.palette.states.billing} 25%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 75%,
        ${theme.palette.states.archive} 75%,
        ${theme.palette.states.archive} 100%)`
    },

    '&$stateDelivery$stateBilling$stateCollection$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 20%,
        ${theme.palette.states.delivery} 20%,
        ${theme.palette.states.delivery} 40%,
        ${theme.palette.states.billing} 40%,
        ${theme.palette.states.billing} 60%,
        ${theme.palette.states.collection} 60%,
        ${theme.palette.states.collection} 80%,
        ${theme.palette.states.paid} 80%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateDelivery$stateBilling$stateCollection$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 20%,
        ${theme.palette.states.delivery} 20%,
        ${theme.palette.states.delivery} 40%,
        ${theme.palette.states.billing} 40%,
        ${theme.palette.states.billing} 60%,
        ${theme.palette.states.collection} 60%,
        ${theme.palette.states.collection} 80%,
        ${theme.palette.states.archive} 80%,
        ${theme.palette.states.archive} 100%)`
    },

    '&$stateDelivery$stateBilling$stateCollection$statePaid$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.intake} 16.66%,
        ${theme.palette.states.delivery} 16.66%,
        ${theme.palette.states.delivery} 33.32%,
        ${theme.palette.states.billing} 33.32%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 66.66%,
        ${theme.palette.states.paid} 66.66%,
        ${theme.palette.states.paid} 83.32%,
        ${theme.palette.states.archive} 83.32%,
        ${theme.palette.states.archive} 100%)`
    }
  },
  stateDelivery: {
    backgroundColor: theme.palette.states.delivery,
    '&$stateBilling': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.billing} 100%)`
    },
    '&$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.paid} 50%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 50%,
        ${theme.palette.states.archive} 50%,
        ${theme.palette.states.archive} 100%)`
    },

    '&$stateBilling$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$stateBilling$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateBilling$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.billing} 33%,
        ${theme.palette.states.billing} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateCollection$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.collection} 33%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
    '&$stateCollection$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.collection} 33%,
        ${theme.palette.states.collection} 66%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$statePaid$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.delivery} 33%,
        ${theme.palette.states.paid} 33%,
        ${theme.palette.states.paid} 66%,
        ${theme.palette.states.archive} 66%,
        ${theme.palette.states.archive} 100%)`
    },
  },
  stateBilling: {
    backgroundColor: theme.palette.states.billing,
    '&$stateCollection': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.collection} 100%)`
    },
    '&$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.paid} 50%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.billing} 50%,
        ${theme.palette.states.archive} 50%,
        ${theme.palette.states.archive} 100%)`
    },
  },
  stateCollection: {
    backgroundColor: theme.palette.states.collection,

    '&$statePaid': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.paid} 50%,
        ${theme.palette.states.paid} 100%)`
    },
    '&$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.collection} 50%,
        ${theme.palette.states.archive} 50%,
        ${theme.palette.states.archive} 100%)`
    },
  },
  statePaid: {
    backgroundColor: theme.palette.states.paid,
    '&$stateGeneral': {
      background: `linear-gradient(to bottom,
        ${theme.palette.states.paid} 50%,
        ${theme.palette.states.archive} 50%,
        ${theme.palette.states.archive} 100%)`
    },
  },
  stateGeneral: {
    backgroundColor: theme.palette.states.archive,
  },
});

const WorkflowState = ({
  workflowState,
  tooltipContent,
  tooltipPlacement,
  className,
  classes,
  ...otherProps
}) => (
  <Tooltip
    className={classNames(classes.root, className)}
    content={(
      <Typography>
        {tooltipContent}
      </Typography>
    )}
    placement="top"
    // color="dark"
    disableGutters
    {...tooltipPlacement ? { placement: tooltipPlacement } : {}}
  >
    <div className={classNames(classes.state, {
      [classes.stateIntake]: workflowState.indexOf(1) !== -1,
      [classes.stateDelivery]: workflowState.indexOf(2) !== -1,
      [classes.stateBilling]: workflowState.indexOf(3) !== -1,
      [classes.stateCollection]: workflowState.indexOf(4) !== -1,
      [classes.statePaid]: workflowState.indexOf(5) !== -1,
      [classes.stateGeneral]: workflowState.indexOf(null) !== -1,
    })} />
  </Tooltip>
);

WorkflowState.propTypes = {
  workflowState: PropTypes.arrayOf(PropTypes.number).isRequired,
  className: PropTypes.string,
  tooltipPlacement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
  }).isRequired,
};

WorkflowState.defaultProps = {
  className: '',
  tooltipPlacement: null,
};

export default withStyles(styles)(WorkflowState);



// WEBPACK FOOTER //
// ./src/components/common/WorkflowState.js